import React, { useEffect, useState, useRef } from 'react';
import { CSVLink } from 'react-csv';
import DataTable from 'react-data-table-component';
import 'antd/dist/antd.css';
import { useHistory } from "react-router-dom";
import { ELETRICITY_BILL_PAYMENT_REPORT2 } from '../../../Utils/appConstants';
import { getRequest } from '../../../Utils/AppApi';
import { UitilityOfflineStatus } from '../../../Utils/Common';
import Invoice from '../../../container/utilityInvoice';

import { Tooltip, Modal } from 'antd';
import { getUTCToLocalDateFormat, getExportFormat, electricityDate } from '../../../Utils/function';

function EletrictiyReport(props) {
    const history = useHistory();
    const csvLink = useRef();
    const limit = 10;

    const startDate = props.startDate || "";
    const endDate = props.endDate || "";
    const search = props.search || "";
    const searchStatus = props.searchStatus || "";

    const [getData, setData] = useState([]);
    const [getCsvData, setCsvData] = useState([]);
    const [getTotalRecord, setTotalRecord] = useState(0);
    const [page, setPage] = useState(1);
    const [isInvoiceModal, setInvoiceModal] = useState(false);
    const [isInvoiceData, setInvoiceData] = useState(null);

    const columns = [
        { 
            name: 'Date', 
            cell: row => electricityDate(row.createdAt), 
            width: "200px" 
        },
        {
            name: 'Transaction ID',
            cell: row => <span className="pointer" onClick={() => handleInvoice(row)}><u>{row.transactionId}</u></span>,
            width: "180px"
        },
        {
            name: 'Partner Id',
            cell: row => <span className="pointer" onClick={() => handleInvoice(row)}><u>{row.partnerUsername || row.userData?.username || '-'}</u></span>,
            width: "160px"
        },
        {
            name: 'Customer Mobile',
            cell: row => row.mobile || row.mobileUnitCycle,
            width: "140px"
        },
        {
            name: 'Provider',
            cell: row => (
                <Tooltip title={row.electricityproviders?.name || 'N/A'}>
                    {row.provider || '-'}
                </Tooltip>
            ),
            width: "140px"
        },
        { 
            name: 'Account Number', 
            selector: row => row.accountNumber || '-', 
            width: "150px" 
        },
        { 
            name: 'Customer Name', 
            selector: row => row.name || '-', 
            width: "150px" 
        },
        { 
            name: 'Due On', 
            selector: row => row.billDueDate ? getUTCToLocalDateFormat(row.billDueDate) : '-', 
            width: "150px" 
        },
        { 
            name: 'Bill Date', 
            cell: row => row.billDate || '-', 
            width: "150px" 
        },
        { 
            name: 'Bill Due Date', 
            cell: row => row.billDueDateOn || '-', 
            width: "150px" 
        },
        { 
            name: 'Amount', 
            selector: row => row.billAmount || 0, 
            width: "120px" 
        },
        { 
            name: 'Status', 
            cell: row => <>{UitilityOfflineStatus(row.status)}</>, 
            width: "130px" 
        },
        {
            name: 'Action',
            cell: row => (
                <div 
                    className='icon-border border border-warning text-warning pointer' 
                    onClick={() => handleInvoice(row)} 
                    title='Invoice'
                >
                    <i className="fas fa-file-invoice"></i>
                </div>
            ),
            width: "100px"
        }
    ];

    const handleInvoice = (data) => {
        const invoiceData = { ...data };

        // Strong mapping for Invoice
        invoiceData.userData = data.userData || {};
        invoiceData.partnerMobile = data.partnerMobile || data.userData?.mobile || '';
        invoiceData.customerMobile = data.mobile || '';           // ← Customer Mobile
        invoiceData.customerName = data.name || '';
        invoiceData.partnerName = data.partnerName || data.userData?.name || '';
        invoiceData.partnerUsername = data.partnerUsername || data.userData?.username || '';

        setInvoiceModal(true);
        setInvoiceData(invoiceData);
    };

    const objectToQueryString = (obj) => {
        const str = [];
        for (const p in obj) {
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        }
        return str.join("&");
    };

    const getDataReports = () => {
        const params = { page, limit };
        if (startDate && endDate) { 
            params.startDate = startDate; 
            params.endDate = endDate; 
        }
        if (search) params.search = search;
        if (searchStatus) params.searchStatus = searchStatus;

        const queryString = objectToQueryString(params);
        
        getRequest(`${ELETRICITY_BILL_PAYMENT_REPORT2}?${queryString}`, history)
            .then((response) => {
                if (response.success) {
                    setData(response.data);
                    setTotalRecord(response.data.totalDocs || 0);
                    setPage(response.data.page || 1);
                } else {
                    setData([]); 
                    setTotalRecord(0); 
                    setPage(1);
                }
            })
            .catch(console.error);
    };

    const getCSVDataList = () => {
        const params = { exportsCsv: true };
        if (startDate && endDate) { 
            params.startDate = startDate; 
            params.endDate = endDate; 
        }
        if (search) params.search = search;
        if (searchStatus) params.searchStatus = searchStatus;

        const queryString = objectToQueryString(params);
        
        getRequest(`${ELETRICITY_BILL_PAYMENT_REPORT2}?${queryString}`, history)
            .then((response) => {
                if (response.success) {
                    const csvdataRecord = response.data.map((e) => ({
                        "Date": getExportFormat(e.updatedAt),
                        "Transaction ID": e.transactionId,
                        "Partner Username": e.partnerUsername || '',
                        "Partner Mobile": e.partnerMobile || '',
                        "Customer Mobile": e.mobile || '',
                        "Provider": e.electricityproviders?.name || 'N/A',
                        "Account Number": e.accountNumber,
                        "Customer Name": e.name,
                        "Bill Date": e.billDate,
                        "Bill Due Date": e.billDueDateOn,
                        "Amount": e.billAmount,
                        "Status": UitilityOfflineStatus(e.status),
                    }));
                    setCsvData(csvdataRecord);
                    setTimeout(() => csvLink.current?.link.click(), 800);
                }
            })
            .catch(console.error);
    };

    const handlePageChange = (page) => setPage(page);
    const handleHideModal = () => setInvoiceModal(false);

    useEffect(() => {
        getDataReports();
    }, [page, props.handleSearch]);

    return (
        <div>
            <div className="container-fluid pt-2 pb-5">
                <div className="col-md-12">
                    <div className='float-sm-right d-flex mb-1'>
                        <button type="button" className="btn btn-primary mr-3" onClick={getCSVDataList}>
                            <i className="fa fa-file-excel"></i> Export
                        </button>
                        <CSVLink 
                            data={getCsvData} 
                            filename='electricity-report.csv' 
                            className='hidden' 
                            ref={csvLink} 
                            target='_blank' 
                        />
                    </div>

                    <div className="box-body">
                        <DataTable
                            title={''}
                            columns={columns}
                            data={getData.docs || []}
                            highlightOnHover
                            pagination
                            paginationServer
                            paginationTotalRows={getTotalRecord}
                            onChangeRowsPerPage={getDataReports}
                            onChangePage={handlePageChange}
                        />
                    </div>
                </div>
            </div>

            {isInvoiceModal && (
                <Modal
                    // title={
                    //     <div className='col-md-12 row text-left'>
                    //         <div className='col-md-6'>
                    //             <img className='text-left' src='../logo.png' alt='logo' width="50%" />
                    //         </div>
                    //     </div>
                    // }
                    width={800}
                    open={isInvoiceModal}
                    footer={false}
                    onCancel={handleHideModal}
                >
                    <Invoice data={isInvoiceData} category="Electrictiy" />
                </Modal>
            )}
        </div>
    );
}

export default EletrictiyReport;